import * as admin from "firebase-admin";
import * as functions from "firebase-functions";

import Admin from "@sentrei/common/models/Admin";
import Notification from "@sentrei/common/models/Notification";
import User from "@sentrei/common/models/User";

const db = admin.firestore();

const notificationCountUpdate = functions.firestore
  .document("users/{userId}/notifications/{notId}")
  .onCreate(async (snap, context) => {
    const {userId} = context.params;
    const data = snap.data() as Notification.Response;

    const userRef = db.doc(`users/${userId}`);
    const user = await userRef.get();
    const userData = user.data() as User.Response;
    const isEnabled = userData.notificationSettings[data.type].includes("app");

    if (!isEnabled) return false;

    return userRef.update(<Admin.Notification>{
      notificationCount: admin.firestore.FieldValue.increment(1),
    });
  });

export default notificationCountUpdate;
